/**
 * @file Emoji component abstraction.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  emoji: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const Emoji = ({ emoji, label, className }) => {
  const classes = classNames({
    emoji: true,
    [className]: !!className,
  });

  return (
    <span className={classes} role="img" aria-label={label}>
      {emoji}
    </span>
  );
};

Emoji.propTypes = propTypes;

export default Emoji;
